import { clientDb } from '../firebase';
import { makeAudit } from '../helpers';
import { UserAuth } from '../interfaces';

const noteFieldsDb = () => clientDb().child('notes-extra-fields');

export type NoteFieldKind =
  | 'text'
  | 'number'
  | 'money'
  | 'boolean'
  | 'textarea'
  | 'date'
  | 'select'
  | 'file';

const VALID_NOTE_FIELD_KINDS: NoteFieldKind[] = [
  'text',
  'number',
  'money',
  'boolean',
  'textarea',
  'date',
  'select',
  'file',
];

const normalizeNoteFieldKind = (kind: unknown): NoteFieldKind => {
  if (typeof kind !== 'string') return 'text';
  if (VALID_NOTE_FIELD_KINDS.includes(kind as NoteFieldKind)) {
    return kind as NoteFieldKind;
  }
  return 'text';
};

export interface NoteFieldDetails {
  name: string;
  kind: NoteFieldKind;
}

export type NoteFieldMap = Record<
  string,
  {
    details: NoteFieldDetails;
  }
>;

export const getAllNoteFields = async (): Promise<NoteFieldMap> => {
  const snapshot = await noteFieldsDb().once('value');
  return (snapshot.val() as NoteFieldMap) || {};
};

export const updateNoteField =
  (user: UserAuth) =>
  async (key: string, details: NoteFieldDetails): Promise<void> => {
    const sanitizedDetails: NoteFieldDetails = {
      name: typeof details?.name === 'string' ? details.name.trim() : '',
      kind: normalizeNoteFieldKind(details?.kind),
    };

    await clientDb().update(
      makeAudit(user, {
        [`notes-extra-fields/${key}`]: { details: sanitizedDetails },
      }),
    );
  };

// export const deleteNoteFields =
//   (user: UserAuth) =>
//   async (ids: string[]): Promise<void> => {
//     const updates: Record<string, null> = {};

//     ids.forEach((id) => {
//       updates[`notes-extra-fields/${id}`] = null;
//     });

//     await clientDb().update(makeAudit(user, updates));
// };

export const deleteNoteField = (user: UserAuth) => async (fieldId: string) => {
  const path = `notes-extra-fields/${fieldId}`;

  await clientDb().update(makeAudit(user, {
    [path]: null
  }));
};